import { Box, Button, Typography } from '@mui/material';
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import React from 'react'
import RemoveIcon from '@mui/icons-material/Remove';
import useContactStore from '../../shared/store/contactStore';
import { CustomButtonContained } from '../../shared/utils/CustomButton';

const ContactPersonList = () => {
    const { contactPersons, removeContactPerson } = useContactStore();
    const contactPersonColumns = [
        {
            field: "name",
            headerName: "Name",
            flex: 1,
            renderCell: (params) =>  <Typography variant="body2" my={2} fontSize={"12px"}>{params.value}</Typography>,
        },
        {
            field: "designation",
            headerName: "Designation",
            flex: 1,
            renderCell: (params) => <Typography variant="body2" fontSize={"12px"}>{params.value}</Typography>,
        },
        {
            field: "mobile_no",
            headerName: "Mobile Number",
            flex: 1,
            renderCell: (params) => <Typography variant="body2" fontSize={"12px"}>{params.value}</Typography>,
        },
        {
            field: "email",
            headerName: "E-Mail",
            flex: 1,
            renderCell: (params) => <Typography variant="body2" fontSize={"12px"}>{params.value}</Typography>,


        },
        {
            field: "actions",
            type: "actions",
            headerName: "Actions",
            flex: 1,
            cellClassName: "actions",
            renderCell: (params) => (
                <Box sx={{ display: "flex", justifyContent: "center", width: "100%" }}>
                    <GridActionsCellItem
                        key={0}
                        icon={<CustomButtonContained buttonText="Remove" />}
                        label="Remove"
                        onClick={() => removeContactPerson(params.id)}
                    />
                </Box>
            ),
        }
        

    ];
    return (
        <DataGrid
            rows={contactPersons}
            columns={contactPersonColumns}
            disableRowSelectionOnClick
            getRowHeight={() => "auto"}
        />
    )
}

export default ContactPersonList